export const RUST_PAGE_TAB = 'RUST_PAGE_TAB'
export const SOLIDITY_PAGE_TAB = 'SOLIDITY_PAGE_TAB'
